import React, { useState, useEffect } from "react";
import "./booklinks.css";

const BOOK_PLATFORMS = [
  {
    value: "amazon_in",
    label: "Amazon Kindle - India",
    icon: "🇮🇳",
    category: "amazon",
  },
  {
    value: "amazon_us",
    label: "Amazon Kindle - United States",
    icon: "🇺🇸",
    category: "amazon",
  },
  {
    value: "amazon_uk",
    label: "Amazon Kindle - United Kingdom",
    icon: "🇬🇧",
    category: "amazon",
  },
  {
    value: "amazon_au",
    label: "Amazon Kindle - Australia",
    icon: "🇦🇺",
    category: "amazon",
  },
  {
    value: "amazon_de",
    label: "Amazon Kindle - Germany",
    icon: "🇩🇪",
    category: "amazon",
  },
  {
    value: "amazon_fr",
    label: "Amazon Kindle - France",
    icon: "🇫🇷",
    category: "amazon",
  },
  {
    value: "amazon_es",
    label: "Amazon Kindle - Spain",
    icon: "🇪🇸",
    category: "amazon",
  },
  {
    value: "amazon_it",
    label: "Amazon Kindle - Italy",
    icon: "🇮🇹",
    category: "amazon",
  },
  {
    value: "amazon_nl",
    label: "Amazon Kindle - Netherlands",
    icon: "🇳🇱",
    category: "amazon",
  },
  {
    value: "amazon_jp",
    label: "Amazon Kindle - Japan",
    icon: "🇯🇵",
    category: "amazon",
  },
  {
    value: "amazon_br",
    label: "Amazon Kindle - Brazil",
    icon: "🇧🇷",
    category: "amazon",
  },
  {
    value: "amazon_ca",
    label: "Amazon Kindle - Canada",
    icon: "🇨🇦",
    category: "amazon",
  },
  {
    value: "amazon_mx",
    label: "Amazon Kindle - Mexico",
    icon: "🇲🇽",
    category: "amazon",
  },
  {
    value: "books2read",
    label: "Books2Read - Universal Link",
    icon: "🌍",
    category: "universal",
  },
  {
    value: "universal",
    label: "Universal Book Link",
    icon: "🌐",
    category: "universal",
  },
  { value: "flipkart", label: "Flipkart", icon: "🛒", category: "other" },
  {
    value: "googlebooks",
    label: "Google Books",
    icon: "📚",
    category: "other",
  },
  { value: "kobo", label: "Kobo", icon: "📖", category: "other" },
  { value: "other", label: "Other Platform", icon: "🔗", category: "other" },
];

function BookLinks() {
  const [bookData, setBookData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchBookLinks = async (orgid) => {
    const sendData = {
      OrgId: Number(orgid),
      ActiveStatus: "A",
      Type: "Zangie_DynamicWebsite Book link",
    };

    try {
      const response = await fetch(
        `https://zaingielatestapi.azurewebsites.net/api/Bill/Getwebsitedatadynamic`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sendData),
        }
      );

      const data = await response.json();
      console.log("Book Links Data:", data);
      setBookData(data);
      setLoading(false);
    } catch (error) {
      console.error("Fetch failed:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const sendData2 = {
        ActualWebsite: window.location.hostname,
        //ActualWebsite: "eh.mounts.in",
        OrgName: "test",
      };

      try {
        await fetch(
          `https://zaingielatestapi.azurewebsites.net/api/FLOW/Getorgiddynamic`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(sendData2),
          }
        )
          .then((response) => response.json())
          .then((data) => {
            const orgid = data.orgId;
            fetchBookLinks(orgid);
          });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="book-links-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading book links...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="book-links-container">
      <div className="book-links-header">
        <h1 className="book-links-title">📚 Get Your Book Now</h1>
        <p className="book-links-subtitle">
          Choose your preferred platform and region to purchase
        </p>
      </div>

      {bookData.map((item, dataIndex) => {
        try {
          const bookLinksData = JSON.parse(item.topLine || "[]");

          if (!Array.isArray(bookLinksData) || bookLinksData.length === 0) {
            return null;
          }

          // Group links by category
          const amazonLinks = bookLinksData.filter((link) =>
            link.platform?.startsWith("amazon_")
          );
          const universalLinks = bookLinksData.filter(
            (link) =>
              link.platform === "books2read" || link.platform === "universal"
          );
          const otherLinks = bookLinksData.filter(
            (link) =>
              !link.platform?.startsWith("amazon_") &&
              link.platform !== "books2read" &&
              link.platform !== "universal"
          );

          return (
            <div key={dataIndex} className="book-section">
              {/* Universal Links - Priority Display */}
              {universalLinks.length > 0 && (
                <div className="universal-section">
                  <h2 className="section-title">
                    <span className="section-icon">🌍</span>
                    Universal Access - All Platforms
                  </h2>
                  <div className="universal-grid">
                    {universalLinks.map((link, linkIndex) => {
                      const platformInfo = BOOK_PLATFORMS.find(
                        (p) => p.value === link.platform
                      );
                      return (
                        <a
                          key={`universal-${linkIndex}`}
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="universal-card"
                        >
                          <div className="card-icon-large">
                            {platformInfo?.icon || "🌐"}
                          </div>
                          <div className="card-badge universal-badge">
                            All Stores
                          </div>
                          <h3 className="card-title">
                            {platformInfo?.label || "Universal Link"}
                          </h3>
                          <p className="card-url">{link.url}</p>
                          <div className="card-cta">
                            <span>Access All Platforms</span>
                            <span className="arrow">→</span>
                          </div>
                        </a>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Amazon Kindle Regional Links */}
              {amazonLinks.length > 0 && (
                <div className="amazon-section">
                  <h2 className="section-title">
                    <span className="section-icon">📦</span>
                    Amazon Kindle - Regional Stores
                  </h2>
                  <div className="amazon-grid">
                    {amazonLinks.map((link, linkIndex) => {
                      const platformInfo = BOOK_PLATFORMS.find(
                        (p) => p.value === link.platform
                      );
                      return (
                        <a
                          key={`amazon-${linkIndex}`}
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="amazon-card"
                        >
                          <div className="card-icon">
                            {platformInfo?.icon || "🇺🇳"}
                          </div>
                          <div className="card-badge amazon-badge">Kindle</div>
                          <h3 className="card-title-small">
                            {platformInfo?.label?.split(" - ")[1] ||
                              platformInfo?.label}
                          </h3>
                          <div className="card-cta-small">
                            <span>Buy Now</span>
                            <span className="arrow">→</span>
                          </div>
                        </a>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Other Platforms */}
              {otherLinks.length > 0 && (
                <div className="other-section">
                  <h2 className="section-title">
                    <span className="section-icon">📚</span>
                    Other Platforms
                  </h2>
                  <div className="other-grid">
                    {otherLinks.map((link, linkIndex) => {
                      const platformInfo = BOOK_PLATFORMS.find(
                        (p) => p.value === link.platform
                      );
                      return (
                        <a
                          key={`other-${linkIndex}`}
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="other-card"
                        >
                          <div className="card-icon-medium">
                            {platformInfo?.icon || "🔗"}
                          </div>
                          <div className="card-badge other-badge">
                            Available
                          </div>
                          <h3 className="card-title-medium">
                            {platformInfo?.label || "Other Platform"}
                          </h3>
                          <p className="card-url-small">{link.url}</p>
                          <div className="card-cta">
                            <span>Buy Now</span>
                            <span className="arrow">→</span>
                          </div>
                        </a>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          );
        } catch (e) {
          console.error("Error parsing book data:", e);
          return null;
        }
      })}
    </div>
  );
}

export default BookLinks;
